import { render, staticRenderFns } from "./HeaderIconsDropdownMenu.vue?vue&type=template&id=fe7dac48&scoped=true&"
import script from "./HeaderIconsDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderIconsDropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7dac48",
  null
  
)

export default component.exports